import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { StickyTabNav } from '@synoptic/ui-kit/tab-nav/sticky-tab-nav.js';
import { Suspense } from 'react';
import { Outlet, useMatch, useSearchParams } from 'react-router';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { StripeDetailsSubmittedModal } from '@/components/stripe-account/stripe-details-submitted-modal.tsx';
import { TabLink } from '@/components/tab-link.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { PricingTypeFilter } from '@/routes/_app.p.marketplace.streams/stream-filters/pricing-type-filter.tsx';
import { StreamFilters } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-filters.tsx';
import { StreamStateFilter } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-state-filter.tsx';
import { StreamTypeFilter } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-type-filter.tsx';
import {
  StreamHeaderActions,
  StreamHeaderFilters,
} from '@/routes/_app.p.marketplace.streams/streams-header/streams-header.tsx';
import { marketplaceOutletNav } from '@/routes/_app.p.marketplace/page.css.ts';

export const ErrorBoundary = ErrorPage;

export const handle = {
  description: () =>
    'Data Streams enable users to create automated, high-volume ' +
    'content feeds. Users can post frequent updates via API, ' +
    'suitable for news services, financial data providers, or social ' +
    'media aggregators. Streams can be customized for various applications.',
  titleAside: () => <StreamHeaderActions />,
  filters: () => <StreamHeaderFilters />,
  children: () => (
    <StripeDetailsSubmittedModal redirectTo={OnboardingLinkPage.Streams} />
  ),
};

export default function Streams() {
  const [searchParams] = useSearchParams();
  const isSearchActive = searchParams.get('q');
  const isAllStreams = useMatch(paths.streams);
  const isTablet = useIsTablet();

  return (
    <>
      {!isSearchActive && (
        <>
          <StickyTabNav
            className={marketplaceOutletNav}
            size={isTablet ? 'large' : 'small'}
          >
            <TabLink end to={paths.streams}>
              All streams
            </TabLink>

            <TabLink to={paths.streamsFollowing}>Following</TabLink>

            <TabLink to={paths.streamsCreated}>Streams you created</TabLink>
          </StickyTabNav>

          <StreamFilters>
            <PricingTypeFilter />
            <StreamStateFilter />
            {!isAllStreams ? <StreamTypeFilter /> : null}
          </StreamFilters>
        </>
      )}

      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </>
  );
}
